import {css} from "@panda/css";
import {AnimatePresence, motion} from "framer-motion";

export const TINDER_MULTI_LEAD_MAX_SHADOWS = 3;

interface IProps {
    reduceMotion: boolean;
    shadowKeys: number[];
}

// Per-depth target geometry (depth 0 = nearest to the front card, widest and lowest).
const depthMotion = [
    {scale: 0.96, y: 24, opacity: 1},
    {scale: 0.9, y: 12, opacity: 1},
    {scale: 0.84, y: 2, opacity: 0.85}
];

const depthColor = ["var(--colors-gray-300)", "var(--colors-gray-200)", "var(--colors-gray-100)"];

export function TinderMultiLeadDeckShadows({reduceMotion, shadowKeys}: IProps) {
    return (
        <div className={shadowLayerStyle} aria-hidden>
            <AnimatePresence>
                {shadowKeys.map((key, depth) => {
                    const clampedDepth = Math.min(depth, TINDER_MULTI_LEAD_MAX_SHADOWS - 1);
                    const target = depthMotion[clampedDepth];

                    return (
                        <motion.span
                            key={key}
                            className={shadowItemStyle}
                            style={{zIndex: TINDER_MULTI_LEAD_MAX_SHADOWS - depth, backgroundColor: depthColor[clampedDepth]}}
                            initial={reduceMotion ? {opacity: 0} : {opacity: 0, scale: target.scale - 0.06, y: target.y - 10}}
                            animate={reduceMotion ? {opacity: target.opacity} : {opacity: target.opacity, scale: target.scale, y: target.y}}
                            exit={reduceMotion ? {opacity: 0} : {opacity: 0, scale: 1.02, y: target.y + 18}}
                            transition={{duration: reduceMotion ? 0.2 : 0.36, ease: [0.4, 0, 0.2, 1], delay: reduceMotion ? 0 : depth * 0.05}}
                        />
                    );
                })}
            </AnimatePresence>
        </div>
    );
}

const shadowLayerStyle = css({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 0,
    height: "80px",
    pointerEvents: "none"
});

const shadowItemStyle = css({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "120px",
    borderRadius: 2,
    transformOrigin: "top center",
    willChange: "transform, opacity"
});
import {css} from "@panda/css";
import {AnimatePresence, motion} from "framer-motion";

export const TINDER_MULTI_LEAD_MAX_SHADOWS = 3;

interface IProps {
    reduceMotion: boolean;
    shadowKeys: number[];
}

// Per-depth target geometry (depth 0 = nearest to the front card, widest and lowest).
const depthMotion = [
    {scale: 0.96, y: 24, opacity: 1},
    {scale: 0.9, y: 12, opacity: 1},
    {scale: 0.84, y: 2, opacity: 0.85}
];

const depthColor = ["var(--colors-gray-300)", "var(--colors-gray-200)", "var(--colors-gray-100)"];

export function TinderMultiLeadDeckShadows({reduceMotion, shadowKeys}: IProps) {
    return (
        <div className={shadowLayerStyle} aria-hidden>
            <AnimatePresence>
                {shadowKeys.map((key, depth) => {
                    const clampedDepth = Math.min(depth, TINDER_MULTI_LEAD_MAX_SHADOWS - 1);
                    const target = depthMotion[clampedDepth];

                    return (
                        <motion.span
                            key={key}
                            className={shadowItemStyle}
                            style={{zIndex: TINDER_MULTI_LEAD_MAX_SHADOWS - depth, backgroundColor: depthColor[clampedDepth]}}
                            initial={reduceMotion ? {opacity: 0} : {opacity: 0, scale: target.scale - 0.06, y: target.y - 10}}
                            animate={reduceMotion ? {opacity: target.opacity} : {opacity: target.opacity, scale: target.scale, y: target.y}}
                            exit={reduceMotion ? {opacity: 0} : {opacity: 0, scale: 1.02, y: target.y + 18}}
                            transition={{duration: reduceMotion ? 0.2 : 0.36, ease: [0.4, 0, 0.2, 1], delay: reduceMotion ? 0 : depth * 0.05}}
                        />
                    );
                })}
            </AnimatePresence>
        </div>
    );
}

const shadowLayerStyle = css({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 0,
    height: "80px",
    pointerEvents: "none"
});

const shadowItemStyle = css({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "120px",
    borderRadius: 2,
    transformOrigin: "top center",
    willChange: "transform, opacity"
});
